import { render, staticRenderFns } from "./Carrinhos.vue?vue&type=template&id=82da229e"
import script from "./Carrinhos.vue?vue&type=script&lang=js"
export * from "./Carrinhos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports